
import React from "react";
import { User } from "lucide-react";
import { Link } from "react-router-dom";
import { Avatar, AvatarImage, AvatarFallback } from "../ui/avatar";

interface DashboardHeaderProps {
  firstName: string | undefined;
  avatarUrl: string | undefined;
}

const DashboardHeader: React.FC<DashboardHeaderProps> = ({
  firstName,
  avatarUrl
}) => {
  return (
    <header 
      className="flex items-center justify-between p-4 bg-transparent preserve-flex" 
      data-testid="dashboard-header"
      style={{ 
        display: 'flex', 
        justifyContent: 'space-between', 
        alignItems: 'center',
        backgroundColor: 'transparent',
        background: 'transparent',
        zIndex: 1,
        position: 'relative',
        paddingTop: 'max(env(safe-area-inset-top, 16px), 24px)',
        marginTop: '20px'
      }}
    >
      <div className="flex-grow" style={{ flexGrow: 1 }}>
        <h1 className="text-2xl font-bold">
          Hello {firstName || "there"}!
        </h1>
        <p className="text-muted-foreground">Let's check on your animals.</p>
      </div>
      <div className="ml-4 flex items-center" style={{ display: 'flex', alignItems: 'center', marginLeft: '1rem' }}>
        <Link to="/account/profile">
          <Avatar>
            <AvatarImage src={avatarUrl} alt={firstName || "Profile"} />
            <AvatarFallback>
              <User className="h-6 w-6 text-gray-500" />
            </AvatarFallback>
          </Avatar>
        </Link>
      </div>
    </header>
  );
};

export default DashboardHeader;
